import ActivityLogSidebar from "../../../components/sidebars/ActivityLogSidebar"
import ApplicationMenuSidebar from "../../../components/sidebars/ApplicationMenuSidebar"
import EnterpriseMenuSidebar from "../../../components/sidebars/EnterpriseMenuSidebar"
import EntStaffSummary from "../../../components/EntStaffSummary"
import OrganizationMenuSidebar from "../../../components/sidebars/OrganizationMenuSidebar"
import OrgStaffSummary from "../../../components/OrgStaffSummary"
import ParticipantGroupSidebar from "../../../components/sidebars/ParticipantGroupSidebar"
import ParticipantSidebar from "../../../components/sidebars/ParticipantSidebar"
import StaffGroupSidebar from "../../../components/sidebars/StaffGroupSidebar"
import StaffSidebar from "../../../components/sidebars/StaffSidebar"

function hasValue(value) {
  return value !== null && value !== undefined && value !== ""
}

function isActivityTemplateId(idTemplate) {
  // Organization-audited forms include both activity logs and non-activity forms,
  // so we gate ActivityLogSidebar behind explicit/pattern-based template matching.
  if (!hasValue(idTemplate)) {
    return false
  }

  // Explicit exceptions for legacy IDs that do not follow a clean naming pattern.
  const explicitActivityTemplateIds = [
    "contact_log",
    "activity_employer_contact",
  ]

  if (explicitActivityTemplateIds.includes(idTemplate)) {
    return true
  }

  // Pattern-based matching for current static activity template families.
  return (
    idTemplate.endsWith("_activity_log") ||
    idTemplate.startsWith("custom_activity_template_")
  )
}

function resolveFormSidebarContent({
  templateAuditType,
  idTemplate,
  currentParticipantId,
  currentStaffMembershipId,
  currentPath,
}) {
  const hasCurrentParticipant = hasValue(currentParticipantId)
  const hasCurrentStaff = hasValue(currentStaffMembershipId)
  const normalizedPath = `${currentPath || ""}`.toLowerCase()
  const isEnterprisePath = normalizedPath.startsWith("/enterprise/")
  const isAdminEnterpriseAddPath =
    normalizedPath.startsWith("/form/enterprise/") &&
    normalizedPath.split("/").filter(Boolean).length === 3

  // ###############################################################
  // Participant forms
  // ###############################################################
  if (templateAuditType === "participant" && idTemplate !== "group_session") {
    if (hasCurrentParticipant) {
      // Existing participant context
      return <ParticipantSidebar />
    } else {
      // New participant intake context
      return <ParticipantGroupSidebar />
    }
  }

  // ###############################################################
  // Staff forms
  // ###############################################################
  if (templateAuditType === "staff") {
    if (idTemplate === "staff") {
      if (isEnterprisePath) {
        return (
          <>
            <EnterpriseMenuSidebar />
            <br />
            <EntStaffSummary />
          </>
        )
      } else {
        return (
          <>
            <OrganizationMenuSidebar />
            <br />
            <OrgStaffSummary />
          </>
        )
      }
    }

    if (idTemplate !== "group_supervision_session") {
      if (hasCurrentStaff) {
        // Existing staff context
        return <StaffSidebar />
      } else {
        // New staff intake context
        return <StaffGroupSidebar />
      }
    }
  }

  // ###############################################################
  // Group session forms
  // ###############################################################
  if (idTemplate === "group_session") {
    return <ParticipantGroupSidebar />
  }

  if (idTemplate === "group_supervision_session") {
    return <StaffGroupSidebar />
  }

  // ###############################################################
  // Enterprise forms
  // ###############################################################
  if (templateAuditType === "enterprise") {
    if (["organization", "location", "program"].includes(idTemplate)) {
      if (isEnterprisePath) {
        return <EnterpriseMenuSidebar />
      } else {
        return <OrganizationMenuSidebar />
      }
    }

    if (idTemplate === "enterprise") {
      if (isAdminEnterpriseAddPath) {
        return <ApplicationMenuSidebar />
      }

      return <EnterpriseMenuSidebar />
    }
  }

  // ###############################################################
  // Organization-audited forms
  // ###############################################################
  if (templateAuditType === "organization") {
    if (isActivityTemplateId(idTemplate)) {
      return <ActivityLogSidebar />
    }
  }

  return null
}

export { resolveFormSidebarContent }
